export function questions(
  state = {
    items: {},
    list: [],
    more: false,
    type: '',
    isTag: 0
  },
  action
) {
  switch (action.type) {
    case 'SET_QUESTIONS': {
      if (state.isTag !== action.questions.isTag) {
        return { ...state, ...action.questions };
      }
      const newQuestions = { ...action.questions };
      newQuestions.items = { ...state.items, ...action.questions.items };
      return { ...state, ...newQuestions };
    }

    case 'SET_QUESTION': {
      const newQuestions = { ...state };
      newQuestions.items[action.question.id] = action.question;
      return { ...state, ...newQuestions };
    }
    case 'SET_QUESTION_PRODUCTS': {
      const newQuestion = { ...state };
      newQuestion.items[action.questionId].products = action.products;
      return { ...state, ...newQuestion };
    }

    case 'MORE_QUESTIONS': {
      const newQuestions = {};
      newQuestions.items = { ...state.items, ...action.questions.items };
      newQuestions.list = state.list.concat(action.questions.list.filter(i => state.list.indexOf(i) === -1));
      newQuestions.more = action.questions.more;
      return { ...state, ...newQuestions };
    }

    case 'PREFETCHED_QUESTIONS': {
      const newQuestions = { ...state };
      newQuestions.items = { ...state.items, ...action.questions.items };
      return { ...state, ...newQuestions };
    }

    case 'REMOVE_QUESTION': {
      const newQuestions = { ...state };
      const { items, list } = newQuestions;
      delete items[action.questionId];
      const deleteFromList = list.indexOf(action.questionId);
      if (deleteFromList > -1) list.splice(deleteFromList, 1);
      return { ...state, ...newQuestions };
    }

    case 'OPTIMISTIC_FOLLOW': {
      const optiQuestions = { ...state };
      optiQuestions.items[action.questionId].following = action.follow;
      return { ...state, ...optiQuestions };
    }

    // Working with api-v4
    case 'OPTIMISTIC_VOTE': {
      const optiQuestions = { ...state };
      const question = optiQuestions.items[action.questionId];
      const votes = question.stats.votes;
      question.stats.votes = action.vote ? votes + 1 : votes - 1;
      return { ...state, ...optiQuestions };
    }

    // Working with api-v4 ?
    case 'OPTIMISTIC_VOTE_ANSWER': {
      const optiQuestions = { ...state };
      const question = optiQuestions.items[action.questionId];
      const optiAnswer = question.answers.find(answer => answer.id === action.answerId);
      const votes = optiAnswer.stats.votes;
      optiAnswer.stats.votes = action.vote ? votes + 1 : votes - 1;
      return { ...state, ...optiQuestions };
    }

    default:
      return state;
  }
}
